import api from "./api";

const MARKETPLACE_OFFER_BASE_URL = "/shipping/offer";
const MARKETPLACE_AGREEMENT_BASE_URL = "/shipping/offer";

const ConversationOfferService = {

    async createOffer(inquiryId, payload) {
        const response = await api.post(
            `${MARKETPLACE_OFFER_BASE_URL}/${inquiryId}/offer`,
            payload
        );

        return response.data;
    },


    async updateProposal(inquiryId, offerId, payload) {
        const response = await api.patch(
            `${MARKETPLACE_OFFER_BASE_URL}/${inquiryId}/offer/${offerId}/proposal`,
            payload
        );

        return response.data;
    },

    async acceptOffer(inquiryId, offerId) {
        const response = await api.post(
            `${MARKETPLACE_OFFER_BASE_URL}/${inquiryId}/offer/${offerId}/accept`
        );

        return response.data;
    },

    async getCurrentOffer(inquiryId) {
        const response = await api.get(
            `${MARKETPLACE_OFFER_BASE_URL}/${inquiryId}/offer`
        );

        return response.data;
    },

    async getOffer(inquiryId, offerId) {
        const response = await api.get(
            `${MARKETPLACE_OFFER_BASE_URL}/${inquiryId}/offer/${offerId}`
        );

        return response.data;
    },

    async createAgreement(inquiryId, payload) {
        const response = await api.post(
            `${MARKETPLACE_AGREEMENT_BASE_URL}/${inquiryId}/agreement`,
            payload
        );

        return response.data;
    },

    async getAgreement(inquiryId, agreementId) {
        const response = await api.get(
            `${MARKETPLACE_AGREEMENT_BASE_URL}/${inquiryId}/agreement/${agreementId}`
        );

        return response.data;
    },

    async rejectOffer(inquiryId, offerId) {
        const response = await api.post(
            `${MARKETPLACE_OFFER_BASE_URL}/${inquiryId}/offer/${offerId}/reject`
        );

        return response.data;
    }

};

export default ConversationOfferService;